'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const FileIsNotAnImageError = ({
  filename
}) => /*#__PURE__*/_jsx(View, {
  marginBlockEnd: "200",
  as: "div",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "FileManagerLib.notifications.upload.expectedImage.message",
    options: {
      filename
    }
  })
});
export default FileIsNotAnImageError;